import * as common from './common.json';

export const uk = {
  common,
};
